import { AspectRatio, Box, chakra } from '@chakra-ui/react'
import ComponentProps from '../../types/ComponentProps'

export interface MediaEmbedProps extends ComponentProps {
  embedCode: string
}

/**
 * @remarks
 * The embed code is set with dangerouslySetInnerHTML. When using this component, you should make sure to sanatize the content in your project.
 *
 * Indicates a element to render embedCode.
 * @param embedCode
 * @returns MediaEmbed
 */
export default chakra(MediaEmbed)

function MediaEmbed({ embedCode, ...props }: MediaEmbedProps) {
  return (
      <Box
      {...props}
        dangerouslySetInnerHTML={{
          __html: embedCode,
        }}
      />
  )
}
